// extracted by mini-css-extract-plugin
export default {"contacto":"Contacto_contacto__F-hTN","emailText":"Contacto_emailText__EDhLE"};